export enum ItemGuideSearchFields {
	searchByName = 'searchByName'
}

export enum ItemGuideFilterFields {
	includeInactive = 'includeInactive'
}

export declare namespace ItemGuide {
	interface Basic extends Entity {
		isActive: boolean
	}

	interface Full extends Basic {
		isWeightRequired: boolean
		chargeTypeId: number
		productCategoryId: number
		productTypeId: number
		productId: number
		productStateId: number
		containerId: number
		unitOfMeasureId: number
		treatmentMethodId: number
		itemsCount: number
	}

	namespace Form {
		interface AddItemGuide extends Omit<Basic, 'id'> {
			name: string
			chargeTypeId: number | null
			productCategoryId: number | null
			productTypeId: number | null
			productId: number | null
			productStateId: number | null
			containerId: number | null
			unitOfMeasureId: number | null
			treatmentMethodId: number | null
			isWeightRequired: boolean
		}

		interface NewItemGuide extends AddItemGuide {}
	}

	type DropdownNames =
		| 'chargeTypeId'
		| 'productCategoryId'
		| 'productTypeId'
		| 'productId'
		| 'productStateId'
		| 'containerId'
		| 'unitOfMeasureId'
		| 'treatmentMethodId'

	namespace Search {
		interface Result {
			[ItemGuideSearchFields.searchByName]: Entity[]
		}
	}
}
